'use client'
import React, { Fragment, useState } from 'react'
import MainMenu from './MainMenu'
import { Maybe, MenuEntityResponse } from '@/gql/generated/graphql'
import ResponsiveImage from '@/components/core/ResponsiveImage'
import Link from 'next/link'
import SocialLinks from '@/components/core/SocialLinks'
import MobileMenu from './MobileMenu'
import Results from './Search/Results'

type Props = {
  menu: Maybe<MenuEntityResponse> | undefined
}

const Header = (props: Props) => {
  const [isOpen, setIsOpen] = useState(false)
  const [isSearchOpen, setIsSearchOpen] = useState(false)

  const handleToggleNav = () => {
    setIsOpen(!isOpen)
  }

  const menuData = props.menu?.data
  if (menuData == undefined) return null
  return (
    <Fragment>
      <header className="header">
        <div
          className="container flex flex-wrap flex-col md:flex-row items-center justify-between"
        >
          <Link href="/" className="logo mb-5 md:mb-0 w-[202px]">
            <ResponsiveImage className='w-full' image={menuData.attributes?.logo} />
          </Link>
          <MainMenu menu={menuData}/>
          <div className="right-box flex items-center justify-center md:justify-end w-full md:w-[370px] lg:w-[326px]">
            {menuData.attributes?.social_link_section && 
              <SocialLinks socialLinksSection={menuData.attributes?.social_link_section} classNames='social-link'/>
            }
            <div className="search-form">
              <form>
                <input type="text" placeholder="Type here to search" onClick={() => setIsSearchOpen(true)} />
                <button type='button' onClick={() => setIsSearchOpen(true)} >search</button>
              </form>
            </div>
            <div onClick={handleToggleNav} className={`open-nav-menu cursor-pointer hidden ml-4`}>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5M12 17.25h8.25" />
              </svg>
            </div>
          </div>
        </div>
      </header>
      <Results onClose={() => setIsSearchOpen(false)} isOpen={isSearchOpen} logo={menuData.attributes?.logo} />
      <MobileMenu menuData={menuData} isOpen={isOpen} handleToggleNav={handleToggleNav}/>
    </Fragment>
  )
}

export default Header